export enum EmployeePosition {
  Manager = 'Manager',
  Accountant = 'Accountant',
  Employee = 'Employee',
  Agronomist = 'Agronomist',
  ChairmanOfTheBoard = 'ChairmanOfTheBoard'
}
